function ExceptionUserExist() {
    const error = new Error();
    return error;
}

ExceptionUserExist.prototype = Object.create(Error.prototype);

export default ExceptionUserExist;
